import {Project, ProjectsInfoPage} from "../types/types";

export const mockProjects: Project[] = [
  {
    id: '1',
    title: 'БМК.',
    subtitle: 'ТОиР',
    description: 'Система автоматизации учёта, планирования и контроля технического обслуживания и ремонта оборудования с применением ИИ-ассистентов.',
    tags: [
      {
        number: 1,
        text: 'Учёт оборудования. Ведение реестра активов с характеристиками: модель, серийный номер, дата ввода в эксплуатацию, местоположение, нормативные сроки обслуживания.'
      },
      {
        number: 2,
        text: 'Планирование работ. Создание графиков планово‑предупредительных ремонтов (ППР) по разным критериям: календарные интервалы, наработка, комбинации стратегий.'
      },
      {
        number: 3,
        text: 'Управление заявками и нарядами. Регистрация внеплановых заявок на ремонт, формирование заданий для исполнителей, контроль сроков исполнения.'
      },
      {number: 4, text: 'Расчет потребностей МТО, учёт затрат.'},
      {
        number: 5,
        text: 'Фиксация выполненных работ. Документирование ремонтов: затраченное время, использованные ресурсы, выявленные дефекты.'
      },
      {
        number: 6,
        text: 'Аналитика и отчётность. Генерация отчётов по:',
        subItems: [
          'Простоям оборудования',
          'Затратам на обслуживание и ремонт',
          'Надёжности узлов',
          'Эффективности исполнителей'
        ]
      },
      {
        number: 7,
        text: 'Мобильный обходчик и мобильный наряд-заказ. Регистрация дефектов, фотофиксация, отчётность в режиме реального времени.'
      },
      {
        number: 8,
        text: 'Встроенные ИИ-ассистенты - эксперты по данным ТОиР, работающие 24/7.'
      }
    ],
    images: [
      require('../../shared/assets/images/projects/toir-1.jpg'),
      require('../../shared/assets/images/projects/toir-2.jpg'),
      require('../../shared/assets/images/projects/toir-3.jpg'),
      require('../../shared/assets/images/projects/toir-4.jpg'),
      require('../../shared/assets/images/projects/toir-5.jpg'),
      require('../../shared/assets/images/projects/toir-6.jpg'),
      require('../../shared/assets/images/projects/toir-7.jpg'),
      require('../../shared/assets/images/projects/toir-8.jpg'),
      require('../../shared/assets/images/projects/toir-9.jpg'),
      require('../../shared/assets/images/projects/toir-10.jpg'),
    ],
    buttons: [
      {
        number: 1,
        text: 'запросить демо',
      },
      {
        number: 2,
        text: 'запросить презентацию',
      }
    ],
    buttonMore: {
      text: 'подробнее...',
      url: 'ТОиР'
    },
  },
  {
    id: '2',
    title: 'БМК.',
    subtitle: 'ИТ',
    description: 'PSA-система для IT-компаний: управление проектами, ресурсами и финансами.',
    tags: [
      {
        number: 1,
        text: 'Управление проектами',
        subItems: [
          'Декомпозиция и оценка трудоемкости и стоимости проекта',
          'Планирование ресурсов',
          'Fixed-price, T&M, Договора сопровождения',
          'Оперативное отслеживание перерасхода по задачам',
          'Финансовые и временные показатели',
          'Автоматическая генерация отчетов и КП для клиентов'
        ]
      },
      {
        number: 2,
        text: 'Учет рабочего времени',
        subItems: [
          'Фиксация времени по задачам и проектам',
          'Разработчик отчитывается только один раз: интеграция с JIRA и другими трекерами, автоматическое распределение воркрепортов по проектам',
          'Контроль полноты заполнения отчетов за каждый месяц',
          'Инструмент выявления "потерянных работ" обеспечивает отсутствие финансовых потерь из-за недовыставленных часов клиенту'
        ]
      },
      {
        number: 3,
        text: 'Управление ресурсами и персоналом',
        subItems: [
          'Учет компетенций и навыков сотрудников',
          'Управление зарплатами и себестоимостью',
          'Планирование отпусков, фиксация больничных',
          'Оценка рентабельности по сотрудникам'
        ]
      },
      {
        number: 4,
        text: 'Финансы и биллинг',
        subItems: [
          'Расчёт себестоимости проектов',
          'Автоматизированное выставление счетов клиентам',
          'Учёт оплат',
          'Прогнозирование денежных потоков',
          'Формирование финансовой отчётности',
          'Формирование отчётов для биллинга и анализа эффективности'
        ]
      },
      {
        number: 5,
        text: 'Аналитика и отчётность',
        subItems: [
          'Дашборды по проектам и загрузке',
          'Отчёты по финансовым показателям',
          'Метрики эффективности команды/РП/компании'
        ]
      }
    ],
    effects: [
      {
        text: 'Эффекты от внедрения',
        subItems: [
          'Повышение прозрачности проектов для клиентов и руководства',
          'Точное планирование сроков и бюджетов за счёт исторических данных',
          'Снижение административной нагрузки на менеджеров и разработчиков',
          'Улучшение качества deliverables через стандартизацию процессов',
          'Рост удовлетворённости клиентов за счёт прозрачности и предсказуемости',
          'Масштабирование бизнеса без пропорционального роста управленческого аппарата',
          'Минимизация потерь от человеческого фактора в управлении проектами'
        ]
      }
    ],
    images: [
      require('../../shared/assets/images/projects/it-1.png'),
      require('../../shared/assets/images/projects/it-2.png'),
      require('../../shared/assets/images/projects/it-3.png'),
      require('../../shared/assets/images/projects/it-4.png'),
      require('../../shared/assets/images/projects/it-5.png'),
    ],
    buttons: [
      {
        number: 1,
        text: 'запросить демо',
      },
      {
        number: 2,
        text: 'запросить презентацию',
      }
    ],
    buttonMore: {
      text: 'подробнее...',
      url: 'БМК.ИТ'
    },
  },
  {
    id: '3',
    title: 'БМК.',
    subtitle: 'ПЛАТФОРМА',
    description: 'Low-code платформа для цифровизации бизнес-процессов компании. Позволяет быстро создавать корпоративные системы управления и автоматизировать внутренние процессы предприятия.',
    subDescription: 'БМК.Платформа позволяет компаниям быстрее выводить цифровые продукты на рынок, снижать затраты на разработку и вовлекать в создание решений не только ИТ‑специалистов, но и бизнес‑пользователей. При этом сохраняется возможность глубокой кастомизации и интеграции с существующей ИТ‑инфраструктурой.',
    tags: [
      {number: 1, text: 'Быстрая реализация и внесение доработок в интерфейс и бизнес-процессы'},
      {number: 2, text: 'Автоматизация взаимодействия с внешними системами'},
      {
        number: 3,
        text: 'Модели данных могут видоизменяться во времени без критических последствий для работы системы в целом'
      },
      {number: 4, text: 'Развертывается on-premise и в облаке'},
      {number: 5, text: 'Архитектура для реализации высоконагруженных систем Enterprise-класса'},
      {number: 6, text: 'Низкий порог входа для новых разработчиков без опыта'},
      {number: 7, text: 'Возможность расширения стандартного функционала внешними модулями'}
    ],
    images: [
      require('../../shared/assets/images/projects/platform-1.png'),
      require('../../shared/assets/images/projects/platform-2.png'),
      require('../../shared/assets/images/projects/platform-3.png'),
      require('../../shared/assets/images/projects/platform-4.png'),
      require('../../shared/assets/images/projects/platform-5.png'),
      require('../../shared/assets/images/projects/platform-6.png'),
    ],
    buttons: [
      {
        number: 2,
        text: 'запросить презентацию',
      }
    ],
    buttonMore: {
      text: 'подробнее...',
      url: 'БМК.ПЛАТФОРМА'
    },
  },
  {
    id: '4',
    title: 'БМК.',
    subtitle: 'ИИ-ассистенты',
    description: 'Разрабатываем и внедряем интеллектуальных ИИ-помощников для работы с вашими ИТ-решениями.',
    subDescription: 'Ассистенты понимают запросы на естественном языке, мгновенно находят информацию, анализируют данные и формируют готовые ответы. Это не просто чат-бот, а полноценный инструмент для принятия решений, который интегрируется в любую корпоративную систему.',
    tags: [
      {
        number: 1,
        text: 'Вопрос-ответ по данным системы',
        subItems: [
          'Пользователь задает вопрос на русском языке, ассистент ищет ответ в вашей базе данных, документации или отчетах и выдает готовый, обоснованный результат.',
        ]
      },
      {
        number: 2,
        text: 'Советник и помощник',
        subItems: [
          'Ассистент не просто ищет данные, но и предлагает оптимальные решения, выявляет риски и дает рекомендации на основе анализа текущей ситуации.',
        ]
      },
      {
        number: 3,
        text: 'Генерация отчетов и аналитика',
        subItems: [
          'Позволяет формировать сложные аналитические отчеты и дашборды по голосовому или текстовому запросу, экономя время руководителей и специалистов.',
        ]
      },
      {
        number: 4,
        text: 'Интеграция с вашими системами',
        subItems: [
          'Ассистенты разрабатываются индивидуально и встраиваются в ваш ИТ-ландшафт, работая с теми данными и бизнес-логикой, которые есть у вас.',
        ]
      },
    ],
    buttons: [
      {
        number: 1,
        text: 'запросить демо',
      },
      {
        number: 2,
        text: 'запросить презентацию',
      }
    ],
    images: [
      require('../../shared/assets/images/projects/ai.jpg'),
      require('../../shared/assets/images/projects/ai2.jpg'),
      require('../../shared/assets/images/projects/ai3.jpg'),
      require('../../shared/assets/images/projects/ai4.jpg'),
      require('../../shared/assets/images/projects/ai5.jpg'),
    ],
  },
  {
    id: '5',
    subtitle: 'Bench',
    description: 'Bench — десктопное AI-агентное приложение (macOS, Windows, Linux), которое работает внутри выбранной пользователем папки-проекта («workspace»).',
    subDescription: 'Это не чат-бот поверх файлов, а агент с полноценным доступом к файловой системе, терминалу, git, браузеру и внешним сервисам, который выполняет задачи от начала до конца, а не только советует. Работа с Bench — это не диалог, который вы сохраняете. Это проект, который вы продолжаете.',
    tags: [
      {
        number: 1,
        text: 'Автономно',
        subItems: ['AI-агент работает без вас, пока вы занимаетесь главным. Задачи, код, документы, отчёты он сам решает, сам делает, сам сообщает результат.'],
      },
      {
        number: 2,
        text: 'Локально',
        subItems: ['Ваши модели, ваши данные, ваши ключи. Ничего не уходит в облако без вашего ведома. Вы выбираете, где и на чём запускать — локально или на вашем сервере.'],
      },
      {
        number: 3,
        text: 'Безопасно',
        subItems: ['Каждое действие — в песочнице. Каждое опасное изменение требует подтверждения. Ничего за периметр проекта — ни файла, ни строки.'],
      },
    ],
    images: [
      require('../../shared/assets/images/projects/Bench-1.png'),
      require('../../shared/assets/images/projects/Bench-2.png'),
      require('../../shared/assets/images/projects/Bench-3.png'),
      require('../../shared/assets/images/projects/Bench-4.png'),
      require('../../shared/assets/images/projects/Bench-5.png'),
    ],
    buttons: [
      {
        number: 1,
        text: 'запросить демо',
      },
      {
        number: 2,
        text: 'запросить презентацию',
      }
    ],
    buttonMore: {
      text: 'подробнее...',
      url: 'Bench'
    },
  }
];

export const projectsInfoPage: ProjectsInfoPage[] = [
  {
    id: 'Bench',
    title: 'Bench',
    description: 'AI-ассистент для работы с кодом, файлами и данными. Локально, в вашем контуре.',
    subDescription: 'Всё, что нужно для работы с кодом, данными и AI — в одном окне.',
    tags: [
      {
        number: 1,
        text: 'Разработка',
        subItems: ['Bench читает проект целиком — правит файлы, работает с git, запускает команды в терминале и пересобирает код, не отвлекая вас.'],
      },
      {
        number: 2,
        text: 'Тестирование',
        subItems: ['Поиск и описание тест-кейсов, автотесты и проверка изменений на дефекты, автоматическая интеграция с эмуляторами и внешними системами. Постоянные агенты прогоняют регресс по расписанию, повторяющиеся процедуры закрепляются как навыки.'],
      },
      {
        number: 3,
        text: 'OpenAI-совместимые модели',
        subItems: ['Подключайтесь к любым облачным API — OpenAI, DeepSeek, Anthropic, Google, Groq и другим — со своим ключом.'],
      },
      {
        number: 4,
        text: 'Локальные модели',
        subItems: ['Ollama, vLLM, LM Studio — запускайте модели на своей машине, без интернета и без ключей.'],
      },
      {
        number: 5,
        text: 'Управление браузером',
        subItems: ['Агент может открывать страницы, кликать, заполнять формы, читать DOM и делать скриншоты — как живой пользователь.'],
      },
      {
        number: 6,
        text: 'Плейты',
        subItems: ['Встраиваемые мини-приложения — дашборды, трекеры, чеклисты, заметки. Работают внутри чата или на отдельной странице.'],
      },
      {
        number: 7,
        text: 'Коннекторы',
        subItems: ['Подключайте внешние HTTP-источники — GitLab, Jira, Sentry, свои API — агент получает контекст там, где он нужен.'],
      },
    ],
    images: [
      require('../../shared/assets/images/projects/Bench-1.png'),
      require('../../shared/assets/images/projects/Bench-2.png'),
      require('../../shared/assets/images/projects/Bench-3.png'),
      require('../../shared/assets/images/projects/Bench-4.png'),
      require('../../shared/assets/images/projects/Bench-5.png'),
    ],
  },
  {
    id: 'ТОиР',
    title: 'ТОиР',
    description: 'Система автоматизации учёта, планирования и контроля технического обслуживания и ремонта оборудования с применением ИИ-ассистентов.',
    subDescription: 'Стоимость: 60 рублей за единицу оборудования, внесенную в базу данных ПО и 240 000 рублей за одно рабочее место в ПО (одного пользователя).',
    info: [
      {
        id: 1,
        name: 'Инструкция для эксплуатации',
        file: '/File/operatingInstructionsMRO.pdf'
      },
      {
        id: 2,
        name: 'Инструкция по установке и настройке',
        file: '/File/installationInstructionsMRO.pdf'
      },
      {
        id: 3,
        name: 'Лицензионный договор БМК.ТОиР',
        file: '/File/licenseAgreement.pdf'
      },
      {
        id: 4,
        name: 'Свидетельство о государственной регистрации программы для ЭВМ ТОиР',
        file: '/File/certificateStateRegistration.pdf'
      },
    ],
    images: [
      require('../../shared/assets/images/projects/toir-1.jpg'),
      require('../../shared/assets/images/projects/toir-2.jpg'),
      require('../../shared/assets/images/projects/toir-3.jpg'),
      require('../../shared/assets/images/projects/toir-4.jpg'),
      require('../../shared/assets/images/projects/toir-5.jpg'),
      require('../../shared/assets/images/projects/toir-6.jpg'),
      require('../../shared/assets/images/projects/toir-7.jpg'),
      require('../../shared/assets/images/projects/toir-8.jpg'),
      require('../../shared/assets/images/projects/toir-9.jpg'),
      require('../../shared/assets/images/projects/toir-10.jpg'),
    ],
  },
  {
    id: 'БМК.ИТ',
    title: 'БМК.ИТ',
    description: 'PSA-система для IT-компаний: управление проектами, ресурсами и финансами.',
    subDescription: 'Стоимость: 500 рублей за одно рабочее место в ПО (одного пользователя).',
    images: [
      require('../../shared/assets/images/projects/it-1.png'),
      require('../../shared/assets/images/projects/it-2.png'),
      require('../../shared/assets/images/projects/it-3.png'),
      require('../../shared/assets/images/projects/it-4.png'),
      require('../../shared/assets/images/projects/it-5.png'),
    ],
    info: [
      {
        id: 1,
        name: 'Инструкция для эксплуатации',
        file: '/File/operatingInstructionsIT.pdf'
      },
      {
        id: 2,
        name: 'Инструкция по установке и настройке',
        file: '/File/installationInstructionsIT.pdf'
      },
      {
        id: 3,
        name: 'Лицензионный договор БМК.ИТ',
        file: '/File/licenseAgreementIT.pdf'
      },
      {
        id: 4,
        name: 'Свидетельство о государственной регистрации программы для ЭВМ',
        file: '/File/certificateStateRegistrationIT.pdf'
      },
    ],
  },
  {
    id: 'БМК.ПЛАТФОРМА',
    title: 'БМК.ПЛАТФОРМА',
    description: 'Low-code платформа для цифровизации бизнес-процессов компании. Позволяет быстро создавать корпоративные системы управления и автоматизировать внутренние процессы предприятия.',
    subDescription: 'Стоимость: 500 рублей за одно рабочее место в ПО (одного пользователя).',
    images: [
      require('../../shared/assets/images/projects/platform-1.png'),
      require('../../shared/assets/images/projects/platform-2.png'),
      require('../../shared/assets/images/projects/platform-3.png'),
      require('../../shared/assets/images/projects/platform-4.png'),
      require('../../shared/assets/images/projects/platform-5.png'),
      require('../../shared/assets/images/projects/platform-6.png'),
    ],
    info: [
      {
        id: 1,
        name: 'Инструкция для эксплуатации',
        file: '/File/operatingInstructionsPlatform.pdf'
      },
      {
        id: 2,
        name: 'Инструкция по установке и настройке',
        file: '/File/installationInstructionsPlatform.pdf'
      },
      {
        id: 3,
        name: 'Лицензионный договор БМК.ИТ',
        file: '/File/licenseAgreementPlatform.pdf'
      },
      {
        id: 4,
        name: 'Свидетельство о государственной регистрации программы для ЭВМ',
        file: '/File/certificateStateRegistrationPlatform.pdf'
      },
    ],
  },
]